import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import './Offers.css';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export default function Offers() {
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/businesses')
      .then(res => {
        const businesses = res.data.data?.businesses || [];
        // Saare products jo discount ke saath hain unhe flat list mein laao
        const allOffers = [];
        businesses.forEach(biz => {
          (biz.products || []).forEach(product => {
            if (product.name) {
              allOffers.push({
                id: `${biz._id}-${product._id}`,
                bizId: biz._id,
                bizName: biz.businessName,
                name: product.name,
                price: product.price,
                discount: product.discount,
                img: product.image ? `${BASE}/${product.image}` : null,
                logo: biz.logo ? `${BASE}/${biz.logo}` : null,
                category: (biz.categories || [])[0] || biz.category || '',
              });
            }
          });
        });
        setOffers(allOffers);
      })
      .catch(() => setOffers([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="offers-page">
      <div className="container">
        <h1 className="offers-title">Offers Nearby</h1>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 60, color: '#64748b' }}>Loading offers...</div>
        ) : offers.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 60, color: '#64748b' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🎁</div>
            <p>No offers available right now.</p>
          </div>
        ) : (
          <div className="offers-grid">
            {offers.map(offer => (
              <div key={offer.id} className="offer-card" onClick={() => navigate(`/business/${offer.bizId}`)}>
                <div className="offer-img-wrap">
                  {offer.img
                    ? <img src={offer.img} alt={offer.name} className="offer-img" />
                    : offer.logo
                      ? <img src={offer.logo} alt={offer.bizName} className="offer-img" />
                      : <div className="offer-img-placeholder">🛒</div>
                  }
                  {offer.discount && (
                    <div className="offer-badge">{offer.discount} off</div>
                  )}
                </div>
                <div className="offer-info">
                  <p className="offer-name">{offer.name}</p>
                  <p className="offer-biz">{offer.bizName}</p>
                  {offer.price && <p className="offer-price">₹{offer.price}</p>}
                  {offer.discount && <p className="offer-save">Save {offer.discount}</p>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
